import {
  Alert,
  Button,
  Col,
  Collapse,
  Divider,
  Form,
  message,
  Row,
  Space,
} from "antd";
import * as ewcms from "../../screen/EWCMS/styleMaster";
import { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import CalendatWithLabels from "../../component/CalendarWithLabels";
import { SaveOutlined, SendOutlined } from "@ant-design/icons";
import "./HourlyPage.less";
import _ from "lodash";
import {
  dataWrapper,
  getClaims,
  navigateBackAction,
} from "../../../redux/actions";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import minMax from "dayjs/plugin/minMax";
import {
  ChangedHrs,
  Claim,
  ClaimDtl,
  SubmitHrs,
} from "../../../types/RequestTypes";
import {
  CALENDAR_DATE,
  COL_SPAN,
  errorMsg,
  requestformItemLayout,
  REQUEST_COL_SPAN,
  MAX_HR_PER_DAY,
  MIN_HR_PER_DAY,
  PAST_MONTH,
  STRING_DATE,
  CLAIM_STATUS,
} from "../../../const/constant";
import ClaimDetailsTable from "./ClaimDetailsTable";
import RequestInfoCol from "./RequestInfoCol";
import ARForm from "./ARForm";
import ConfirmSubmitModal from "../../component/ConfirmSubmitModal";
import ConfirmDelDraftModal from "../../component/ConfirmDelDraftModal";
import { RootState } from "../../../redux/reducers";

dayjs.extend(duration);
dayjs.extend(minMax);

function HourlyPage(props) {
  const { currDuty, navigateBack, dataFetch, fetchClaims, claims, device } =
    props;
  //Calendar State - changedHr = those claims is able to edit
  const [changedHr, setChangedHr] = useState<ChangedHrs>({});
  //Button State
  const [submit, setSubmit] = useState<"Draft" | "Submit">();
  //Navigate Back State
  const [back, setBack] = useState<boolean>(false);
  //Total Hrs State
  const [hrsInputted, setHrsInputted] = useState<number>(0);
  const [draftHrs, setDraftHrs] = useState<number>(0);
  // <SubmitRequestModal /> State;
  const [showSubmitModal, setShowSubmitModal] = useState<boolean>(false);
  const [submitValue, setSubmitValue] = useState<{ [key: string]: any }>({});
  // Delete All Draft
  const [showDelDraftModal, setShowDelDraftModal] = useState<boolean>(false);
  const [isDraftRecord, setIsDraftRecord] = useState<boolean>(false);
  // Rejected Submit
  const [rejectedBatchNo, setRejectedBatchNo] = useState<string>("");

  const selectedClaim: any = useSelector(
    (state: RootState) => state.data.select_claim
  );

  const start_date = dayjs(currDuty.START_DATE);
  //const end_date = dayjs.min(dayjs(currDuty.END_DATE), dayjs().endOf("month"));
  // temp fix when end in current month
  const end_date = dayjs.min(
    //dayjs(currDuty.END_DATE).isBetween(dayjs().startOf("month"), dayjs().endOf("month")) ? dayjs(currDuty.END_DATE).add(1, "day") : dayjs(currDuty.END_DATE),
    dayjs(currDuty.END_DATE).isSame(dayjs(), "month") || dayjs(currDuty.END_DATE).isAfter(dayjs(), "month") ? 
      dayjs(currDuty.END_DATE).add(1, "day") : 
      dayjs(currDuty.END_DATE),
    dayjs().endOf("month")
  );

  useEffect(() => {
    if (selectedClaim) {
      const { BATCH_NO: batchNo } = selectedClaim;
      setRejectedBatchNo(batchNo);
    }
  }, [selectedClaim]);

  useEffect(() => {
    if (claims && claims.length) {
      let d_hr = 0;
      let newChangedHr = { ...changedHr };
      claims.forEach((claim: Claim) => {
        const {
          CLAIMS_DETAILS: claimsDetails,
          STATUS: status,
          REMARKS: remarks,
          BATCH_NO: batchNo,
        } = claim;

        if (
          !rejectedBatchNo ||
          (rejectedBatchNo && batchNo === rejectedBatchNo)
        ) {
          if (claimsDetails && claimsDetails.length) {
            claimsDetails.forEach((detail: ClaimDtl) => {
              const claimDate = dayjs(detail.CLAIM_DATE);
              if (status === "I" && !selectedClaim) {
                d_hr += detail.HR_CLAIM;
                newChangedHr[claimDate.format(CALENDAR_DATE)] = {
                  date: claimDate,
                  hr: detail.HR_CLAIM,
                  prevHr: detail.HR_CLAIM,
                  prevState: status,
                };
              }
              //If reject and state HAS preV status, override status ONLY
              else if (
                status === "R" &&
                selectedClaim &&
                batchNo === selectedClaim?.BATCH_NO
              ) {
                if (claimDate.format(CALENDAR_DATE) in newChangedHr) {
                  d_hr += detail.HR_CLAIM;
                  newChangedHr[claimDate.format(CALENDAR_DATE)] = {
                    ...newChangedHr[claimDate.format(CALENDAR_DATE)],
                    prevState: status,
                    remarks: remarks,
                  };
                } else {
                  d_hr += detail.HR_CLAIM;
                  newChangedHr[claimDate.format(CALENDAR_DATE)] = {
                    date: claimDate,
                    hr: detail.HR_CLAIM,
                    prevHr: detail.HR_CLAIM,
                    prevState: status,
                    remarks: remarks,
                  };
                }
              }
            });
          }
        }
      });
      setChangedHr(newChangedHr);
      setDraftHrs(d_hr);
    } else {
      setDraftHrs(0);
    }
  }, [claims, rejectedBatchNo]);

  useEffect(() => {
    if (claims && claims?.length) {
      claims.forEach((claim: Claim) => {
        if ((claim.STATUS === "I" || claim.STATUS === "R") && !isDraftRecord) {
          setIsDraftRecord(true);
        }
      });
    }
  }, [claims]);

  useEffect(() => {
    let hrs = 0;
    if (changedHr) {
      for (const value of Object.values(changedHr)) {
        hrs += value.hr;
      }
    }
    setHrsInputted(hrs);
  }, [changedHr]);

  useEffect(() => {
    if (back) {
      navigateBack();
    }
  }, [back, navigateBack]);

  const rejectAlerts = (claims as Claim[])
    .filter((value) => {
      return (
        value.STATUS === CLAIM_STATUS.REJECTED &&
        value.REMARKS &&
        value.BATCH_NO === selectedClaim?.BATCH_NO
      );
    })
    .map((value) => {
      return (
        <Alert
          key={value.SP_SUP_CLAIM_PK}
          message={`Rejected Payment Request: ${dayjs(value.START_DATE).format(
            STRING_DATE
          )} to ${dayjs(value.END_DATE).format(STRING_DATE)} - ${
            value.TOT_HR_CLAIM
          } hr(s) : ${value.REMARKS}`}
          type="warning"
          showIcon
          closable
        />
      );
    });

  //MAX - PAID
  const remainHrs = currDuty.HR_MAX - currDuty.HR_PAID - hrsInputted + draftHrs;

  const max_date_curr = dayjs().startOf("d").subtract(PAST_MONTH, "month");

  const onFinish = async (value: { Approver: string; Endorser: string }) => {
    let omitDateHr: SubmitHrs = {};
    if (remainHrs < 0) {
      errorMsg(
        "The record cannot be saved/submitted as the number of hour(s) entered exceeds the limit of remaining hour(s)."
      );
      return;
    }
    if (value.Approver === value.Endorser) {
      errorMsg("Approver and Endorser should not be the same.");
      return;
    }
    if (changedHr) {
      for (const [key, value] of Object.entries(changedHr)) {
        if (value.hr > MAX_HR_PER_DAY) {
          // errorMsg(
          //   `${dayjs(value.date).format(
          //     STRING_DATE
          //   )} has more than ${MAX_HR_PER_DAY} hours`
          // );
          errorMsg(
            `You Cannot input more than ${MAX_HR_PER_DAY} hours in a day.`
          );
          return;
        }
        if (value.hr < MIN_HR_PER_DAY) {
          errorMsg(
            `${dayjs(value.date).format(
              STRING_DATE
            )}} has less than ${MIN_HR_PER_DAY} hour`
          );
          return;
        }
        omitDateHr[key] = _.omit(value, ["date"]);
      }
    }
    const submit_json = {
      STAFF_NO: currDuty.STAFF_NO,
      DUTY_PK: currDuty.SP_DUTY_PK,
      REQUEST_TYPE: currDuty.RATE_TYPE,
      CALENDAR_INFO: omitDateHr,
      BATCH_NO: selectedClaim ? selectedClaim.BATCH_NO : null,
      ...value,
    };
    // console.log(`*****submit_json:`, submit_json);
    if (submit === "Draft") {
      //Call SAVE DRAFT
      const response = await dataFetch(
        "ptps/makeDraftRequest",
        { value: submit_json },
        "POST"
      );
      if (response?.result === "0") {
        //Show success message
        message.success("Draft Saved Successfully");
        setChangedHr({});
        fetchClaims(currDuty.SP_DUTY_PK);
        //Fetch new Result
      } else {
        errorMsg(response?.error);
      }
    } else if (submit === "Submit") {
      setShowSubmitModal(true);
      setSubmitValue(submit_json);
    }
  };

  const onConfirmSubmit = async () => {
    const response = await dataFetch(
      "ptps/makeSubmitRequest",
      { value: submitValue },
      "POST"
    );
    if (response?.result === "0") {
      //Show success message
      message.success("Submission Completed");
      fetchClaims(currDuty.SP_DUTY_PK);
      setBack(true);
    } else {
      errorMsg(response?.error);
    }
  };

  const onConfirmDelDraft = async () => {
    const response = await dataFetch(
      "ptps/deletePaymentRequestDraft",
      {
        data: {
          dutyPk: currDuty.SP_DUTY_PK,
          claimPk: null,
          staffNo: currDuty.STAFF_NO,
          requestType: "H",
          batchNo: rejectedBatchNo ? rejectedBatchNo : null,
        },
      },
      "POST"
    );
    if (response?.result === "0") {
      //Show success message
      const successMsg = `The ${
        rejectedBatchNo ? "rejected" : ""
      } payment request has been deleted.`;
      message.success(successMsg);
      setChangedHr({});
      fetchClaims(currDuty.SP_DUTY_PK);
      setShowDelDraftModal(false);
      setIsDraftRecord(false);
      setBack(rejectedBatchNo ? true : false);
    } else {
      setShowDelDraftModal(false);
      errorMsg(response?.error);
    }
  };

  const extraCol = (
    <>
      <Col span={COL_SPAN[device.size][0]}>Max. Hour:</Col>
      <Col span={COL_SPAN[device.size][1]}>{currDuty.HR_MAX}</Col>
    </>
  );

  return (
    <div style={{ padding: "1rem 0" }}>
      <RequestInfoCol extraCol={extraCol} />
      <Divider />
      <Space
        direction="vertical"
        style={{ width: "100%", marginBottom: "24px" }}
      >
        {rejectAlerts}
      </Space>
      {/*Endorsed users table*/}
      <Collapse defaultActiveKey={["1"]}>
        <Collapse.Panel header={"Payment Request Form"} key="1">
          <Form
            onFinish={onFinish}
            className="calendar-form"
            layout={device.size !== "mobile" ? "horizontal" : "vertical"}
            {...requestformItemLayout[device.size]}
          >
            <Row gutter={[0, 16]}>
              <ARForm select_claim={selectedClaim} />
              <Col span={REQUEST_COL_SPAN[device.size][0]}>
                Total no. of hours inputted:
              </Col>{" "}
              <Col span={REQUEST_COL_SPAN[device.size][1]}>
                <b>{Math.round(hrsInputted * 100) / 100}</b>
              </Col>
              <Col span={REQUEST_COL_SPAN[device.size][0]}>
                Remaining hours:
              </Col>{" "}
              <Col span={REQUEST_COL_SPAN[device.size][1]}>
                <b>{Math.round(remainHrs * 100) / 100}</b>
              </Col>
              <Col span={24} style={{ fontStyle: "italic" }}>
                Please enter working hours:
              </Col>
            </Row>
            <CalendatWithLabels
              claims={claims}
              validRange={[
                start_date,
                end_date,
              ]}
              disableFieldBefore={max_date_curr}
              changedHr={changedHr}
              setChangedHr={setChangedHr}
              rateType={currDuty.RATE_TYPE}
              isApprover={false}
              isEndorser={false}
              rejectedBatchNo={rejectedBatchNo}
            />
            <Row
              gutter={[16, 16]}
              style={{ marginTop: "1rem", marginBottom: "1rem" }}
            >
              {selectedClaim ? (
                <></>
              ) : (
                <Col>
                  <Button
                    onClick={() => {
                      setSubmit("Draft");
                    }}
                    type="primary"
                    htmlType="submit"
                    icon={<SaveOutlined />}
                  >
                    Save
                  </Button>
                </Col>
              )}
              <Col>
                <Button
                  onClick={() => {
                    setSubmit("Submit");
                  }}
                  type="primary"
                  htmlType="submit"
                  icon={<SendOutlined />}
                >
                  Submit
                </Button>
              </Col>
              {isDraftRecord ? (
                <Col>
                  <Button
                    className={ewcms.defaultBtnStyle + " cust-button-height"}
                    onClick={() => {
                      setShowDelDraftModal(true);
                    }}
                    htmlType="button"
                  >
                    Delete
                  </Button>
                </Col>
              ) : (
                <></>
              )}
              <Col>
                <Button
                  onClick={() => {
                    setBack(true);
                  }}
                  htmlType="button"
                >
                  Cancel
                </Button>
              </Col>
            </Row>

            <ConfirmSubmitModal
              showModal={showSubmitModal}
              setshowModal={setShowSubmitModal}
              title={""}
              onConfirmSubmit={onConfirmSubmit}
            />

            <ConfirmDelDraftModal
              setShowDelDraftModal={setShowDelDraftModal}
              showDelDraftModal={showDelDraftModal}
              onConfirmDelDraft={onConfirmDelDraft}
              isRejectedMode={rejectedBatchNo ? true : false}
            />
          </Form>
        </Collapse.Panel>
        <Collapse.Panel header={"Payment Request History"} key="2">
          <ClaimDetailsTable claims={claims} hideCol={[]} />
        </Collapse.Panel>
      </Collapse>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    currDuty: state.data.currDuty,
    device: state.session.device,
    approver: state.data.approver,
    endorser: state.data.endorser,
    claims: state.data.claims,
  };
};

const mapDispatchToProps = (dispatch) => ({
  reset: () => {
    dispatch({ type: "RESET-RESULT" });
  },
  navigateBack: () => {
    dispatch(navigateBackAction());
  },
  dataFetch: (apiPath, data, method) => {
    return dispatch(dataWrapper(apiPath, data, method));
  },
  fetchClaims: (duty_pk) => {
    return dispatch(getClaims(duty_pk));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(HourlyPage);
